"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _arrays = require("@mulesoft/exchange-ui-portals-store/lib/utils/arrays");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _reactRedux = require("react-redux");
var _react = _interopRequireWildcard(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _semver = _interopRequireDefault(require("semver"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var dateUtils = _interopRequireWildcard(require("../../../utils/date"));
var _LifecycleStatePill = _interopRequireDefault(require("../../LifecycleState/LifecycleStatePill"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 1-1zM7 6H5v3.99h14V6h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6zm12 5.99H5V20h14v-8.01z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 14H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
  }));
};
CalendarIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var cardStyles = {
  "container": "AssetCard__container__1teJw",
  "asset-title": "AssetCard__asset-title__3WiAo",
  "assetTitle": "AssetCard__asset-title__3WiAo",
  "asset-card": "AssetCard__asset-card__2iQEf",
  "assetCard": "AssetCard__asset-card__2iQEf",
  "override": "AssetCard__override__33nJK",
  "description": "AssetCard__description__3MpvF",
  "version": "AssetCard__version__1Abn0",
  "detail": "AssetCard__detail__29UNK",
  "rating": "AssetCard__rating__2yb0N",
  "name": "AssetCard__name__1vrTi",
  "icon": "AssetCard__icon__AoJmh",
  "tags-container": "AssetCard__tags-container__2t7B7",
  "tagsContainer": "AssetCard__tags-container__2t7B7",
  "matches-tags": "AssetCard__matches-tags__1ABXA",
  "matchesTags": "AssetCard__matches-tags__1ABXA",
  "matches-categories": "AssetCard__matches-categories__1PQSu",
  "matchesCategories": "AssetCard__matches-categories__1PQSu",
  "matches-table": "AssetCard__matches-table__3KrTq",
  "matchesTable": "AssetCard__matches-table__3KrTq",
  "row-title": "AssetCard__row-title__1EWa5",
  "rowTitle": "AssetCard__row-title__1EWa5",
  "row-content": "AssetCard__row-content__18NmT",
  "rowContent": "AssetCard__row-content__18NmT",
  "metadata": "AssetCard__metadata__1HjVL",
  "number-of-rates": "AssetCard__number-of-rates__2AViT",
  "numberOfRates": "AssetCard__number-of-rates__2AViT",
  "metadata-item": "AssetCard__metadata-item__2ztCa",
  "metadataItem": "AssetCard__metadata-item__2ztCa",
  "metadata-item-wrapper": "AssetCard__metadata-item-wrapper__DMBFE",
  "metadataItemWrapper": "AssetCard__metadata-item-wrapper__DMBFE"
}; 
require('../AssetCard.css');
var styles = {
  "icon": "Versions__icon__3wKSu",
  "version-row": "Versions__version-row__2LMXH",
  "versionRow": "Versions__version-row__2LMXH",
  "pill-row": "Versions__pill-row__2DoDw",
  "pillRow": "Versions__pill-row__2DoDw",
  "date-row": "Versions__date-row__115Ux",
  "dateRow": "Versions__date-row__115Ux",
  "date-content": "Versions__date-content__20gog",
  "dateContent": "Versions__date-content__20gog"
}; 
require('./Versions.css');
var LoadingVersions = function LoadingVersions() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.loaderWrapper,
    "data-test-id": "match-versions-loading"
  }, /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    height: 16,
    viewBox: "0 0 120 20"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: 120,
    height: 20
  })));
};
var compareFn = function compareFn(a, b) {
  if (a.version) {
    return _semver.default.rcompare(a.version, b.version);
  }
  return _semver.default.rcompare(a, b);
};
var getVersionText = function getVersionText(version, searchedStatus) {
  var versionText = (version === null || version === void 0 ? void 0 : version.version) || version;
  var versionStatus = (version === null || version === void 0 ? void 0 : version.status) || null;
  if (searchedStatus.includes(versionStatus)) {
    return "<em>".concat(versionText, "</em>");
  }
  return "".concat(versionText);
};
var useSearchedStatus = function useSearchedStatus() {
  var rootStoreContext = (0, _react.useContext)(_exchangeReactHooks.RootStoreContext);
  var useSelector = (0, _reactRedux.createSelectorHook)(_exchangeReactHooks.RootStoreContext);
  var homeQuery = useSelector(function (state) {
    var _state$common;
    return (_state$common = state.common) === null || _state$common === void 0 ? void 0 : _state$common.homeQuery;
  });
  if (!rootStoreContext) {
    return [];
  }
  return (0, _arrays.convertToArray)(homeQuery === null || homeQuery === void 0 ? void 0 : homeQuery.status);
};
var Versions = function Versions(_ref) {
  var _ref$versions = _ref.versions,
    versions = _ref$versions === void 0 ? [] : _ref$versions,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$fetchVersionsPro = _ref.fetchVersionsPromise,
    fetchVersionsPromise = _ref$fetchVersionsPro === void 0 ? null : _ref$fetchVersionsPro,
    _ref$onFetchStart = _ref.onFetchStart,
    onFetchStart = _ref$onFetchStart === void 0 ? function () {} : _ref$onFetchStart,
    _ref$onFetchEnd = _ref.onFetchEnd,
    onFetchEnd = _ref$onFetchEnd === void 0 ? function () {} : _ref$onFetchEnd,
    _ref$hasFetchedVersio = _ref.hasFetchedVersions,
    hasFetchedVersions = _ref$hasFetchedVersio === void 0 ? false : _ref$hasFetchedVersio,
    groupId = _ref.groupId,
    assetId = _ref.assetId,
    minorVersion = _ref.minorVersion;
  var handleError = (0, _exchangeReactHooks.useErrorHandling)();
  var fetch = (0, _exchangeReactHooks.useFetch)();
  var searchedStatus = useSearchedStatus();
  function fetchVersions() {
    return _fetchVersions.apply(this, arguments);
  }
  function _fetchVersions() {
    _fetchVersions = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var response, result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("/api/v2/ang/assets/".concat(groupId, "/").concat(assetId, "/minorVersions/").concat(minorVersion, "/versions"));
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            result = _context.sent;
            return _context.abrupt("return", result);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            handleError(_context.t0, fetchVersions);
          case 13:
            return _context.abrupt("return", null);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return _fetchVersions.apply(this, arguments);
  }
  function loadVersions(_x) {
    return _loadVersions.apply(this, arguments);
  }
  function _loadVersions() {
    _loadVersions = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2($fetchVersionsPromise) {
      var promise, fetchedVersions;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            promise = $fetchVersionsPromise;
            if (!$fetchVersionsPromise) {
              promise = fetchVersions();
              onFetchStart(promise);
            }
            _context2.next = 4;
            return promise;
          case 4:
            fetchedVersions = _context2.sent;
            onFetchEnd(fetchedVersions);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _loadVersions.apply(this, arguments);
  }
  _react.default.useEffect(function () {
    if (isExpanded && !hasFetchedVersions || fetchVersionsPromise) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadVersions(fetchVersionsPromise);
    }
  }, [isExpanded]);
  _react.default.useEffect(function () {
    var target = document.querySelector("[data-card-asset-id=\"".concat(assetId, "\"] tr[data-highlighted=\"true\"]"));
    var parent = document.querySelector("[data-scrollable-asset-id=\"".concat(assetId, "\"]"));
    if (target) {
      parent.scrollTop = target.offsetTop;
    }
  }, [fetchVersionsPromise]);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: cardStyles.matchesTable,
    "data-test-id": "asset-card-versions"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, versions.sort(compareFn).map(function (version) {
    var lifecycleState = !version.status ? /*#__PURE__*/_react.default.createElement(LoadingVersions, null) : /*#__PURE__*/_react.default.createElement(_LifecycleStatePill.default, {
      status: version.status,
      lightTheme: true
    });
    var createdDate = version !== null && version !== void 0 && version.createdAt ? dateUtils.formatRelativeDate(version === null || version === void 0 ? void 0 : version.createdAt) : '';
    var createdDateComponent = !version.createdAt ? /*#__PURE__*/_react.default.createElement(LoadingVersions, null) : /*#__PURE__*/_react.default.createElement("div", {
      title: "Published Date",
      className: styles.dateRow
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      size: "xs"
    }, /*#__PURE__*/_react.default.createElement(CalendarIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dateContent
    }, createdDate[0].toUpperCase() + createdDate.substring(1)));
    var versionText = getVersionText(version, searchedStatus);
    var isHighlighted = versionText.includes('em');
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "version-".concat(versionText),
      "data-highlighted": isHighlighted ? 'true' : 'false'
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: styles.versionRow
    }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, versionText)), /*#__PURE__*/_react.default.createElement("td", {
      className: styles.versionRow
    }, createdDateComponent), /*#__PURE__*/_react.default.createElement("td", {
      className: styles.pillRow
    }, lifecycleState));
  })));
};
var _default = exports.default = Versions;
//# sourceMappingURL=Versions.js.map